import clsx from 'clsx'

interface RankBadgeProps {
  rank: number
  prevRank: number | null
  size?: 'sm' | 'md' | 'lg'
}

const sizeClasses = {
  sm: 'text-sm',
  md: 'text-base',
  lg: 'text-xl',
}

export function RankBadge({ rank, prevRank, size = 'md' }: RankBadgeProps) {
  const delta = prevRank ? prevRank - rank : 0
  const direction = delta > 0 ? 'up' : delta < 0 ? 'down' : 'same'

  return (
    <div className={clsx('flex items-center gap-1.5', sizeClasses[size])}>
      <span className="font-mono font-bold text-slate-100" style={{ fontVariantNumeric: 'tabular-nums' }}>
        {rank}
      </span>
      {prevRank != null && delta !== 0 && (
        <span className={clsx(
          'flex items-center gap-0.5 text-xs font-medium',
          direction === 'up' ? 'text-trend-up' : 'text-trend-down',
        )}>
          <svg
            className={clsx('w-3 h-3', direction === 'down' && 'rotate-180')}
            viewBox="0 0 12 12"
            fill="currentColor"
          >
            <path d="M6 2l4 5H2z" />
          </svg>
          <span style={{ fontVariantNumeric: 'tabular-nums' }}>{Math.abs(delta)}</span>
        </span>
      )}
    </div>
  )
}
